export const STYLES = [
  { id: 'Stealth', label: 'Stealth metal' },
  { id: 'Player', label: 'Player card' },
];
export const TIERS = ['Silver', 'Gold', 'Elite'];
export const SYMBOLS = ['Alpha', 'Monogram'];
export const SHAPES = ['Cut corners', 'Classic'];

/** sample ratings per tier (the real ones come from the trader's history) */
export const SAMPLE_STATS = {
  Silver: {
    overall: 72,
    top: 35,
    stats: [
      ['EDGE', 'EDG', 70],
      ['RISK', 'RSK', 78],
      ['CONSISTENCY', 'CON', 68],
      ['EXECUTION', 'EXE', 71],
    ],
  },
  Gold: {
    overall: 84,
    top: 12,
    stats: [
      ['EDGE', 'EDG', 84],
      ['RISK', 'RSK', 91],
      ['CONSISTENCY', 'CON', 78],
      ['EXECUTION', 'EXE', 80],
    ],
  },
  Elite: {
    overall: 93,
    top: 1,
    stats: [
      ['EDGE', 'EDG', 94],
      ['RISK', 'RSK', 96],
      ['CONSISTENCY', 'CON', 90],
      ['EXECUTION', 'EXE', 92],
    ],
  },
};

export const DEFAULT_CONFIG = {
  name: '',
  style: 'Stealth',
  tier: 'Gold',
  symbol: 'Alpha',
  shape: 'Cut corners',
};

/** Keeps only known values (for designs read back from storage). */
export function sanitize(raw) {
  const pick = (v, ok, d) => (ok.includes(v) ? v : d);
  return {
    name: typeof raw.name === 'string' ? raw.name.slice(0, 18) : '',
    style: pick(
      raw.style,
      STYLES.map((s) => s.id),
      DEFAULT_CONFIG.style,
    ),
    tier: pick(raw.tier, TIERS, DEFAULT_CONFIG.tier),
    symbol: pick(raw.symbol, SYMBOLS, DEFAULT_CONFIG.symbol),
    shape: pick(raw.shape, SHAPES, DEFAULT_CONFIG.shape),
  };
}

export function initials(name) {
  const parts = (name || 'Your Name').trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? 'Y';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + last).toUpperCase();
}
